import templateUrl from './process-tax-notice-completed.component.html';

export const ProcessTaxNoticeCompletedComponent = {
    templateUrl,
    controller: ProcessTaxNoticeCompletedController,
    controllerAs: "vm",
};

function ProcessTaxNoticeCompletedController(taxNoticeService, employeeService,
    utilityService, taxNoticeUpdateService) {
    'ngInject';
    const vm = this;
    vm.documents = [];
    vm.documentsbk = [];
    vm.toggle = toggle;
    vm.download = download;
    vm.cancel = cancel;

    vm.allComments = [];
    vm.comment = comment;
    vm.isComment = false;
    vm.onSelectCommentFile = onSelectCommentFile;
    vm.noticeCommentFiles;
    vm.commentFileName;

    vm.isStatusHistory = false;
    vm.statusHistory = statusHistory;
    vm.allStatuses = [];
    vm.userName;
    vm.close = close;
    vm.filters;
    vm.onChangeFilters = onChangeFilters;

    vm.$onInit = function () {
        utilityService.showLoading();
        taxNoticeUpdateService.taxNoticeRefreshEvents$.forEach(event => {
            if (event === "update") {
                refreshData();
            }
        });
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName
                taxNoticeService.retrieveCompletedDocuments(result.UserName)
                    .then(function (mydocs) {
                        vm.documents = mydocs;
                        vm.documentsbk = mydocs;
                        return result;
                    })
            })
            .catch((err) => {
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            })
        utilityService.hideLoading();
    };
    function close() {
        vm.isStatusHistory = false;
        vm.isComment = false;
    }
    function cancel() {
        vm.isStatusHistory = false;
        vm.isComment = false;
    }
    function comment(noticeDocumentId: any, fileName: any) {
        utilityService.showLoading();
        vm.isComment = true;
        vm.taxNoticeDocumentId = noticeDocumentId;
        vm.fileName = fileName;

        taxNoticeService.retrieveComments(vm.taxNoticeDocumentId)
            .then(function (result) {
                vm.allComments[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                alert("Comment: " + utilityService.getExceptionMessage(err));
            })
    }
    function onSelectCommentFile() {
        vm.commentFileName = vm.noticeCommentFiles.name;
    }
    function toggle(document: any, description: string) {
        if (document.Description !== description) {
            taxNoticeService.updateDescription({
                TaxNoticeDocumentId: document.NoticeDocumentId,
                Text: description
            }).then(function (result) {
            }).catch(function (ex) {
                console.log('Change failed');
            });
        }
    }

    function refreshData() {
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName
                taxNoticeService.retrieveCompletedDocuments(vm.userName)
                    .then(function (mydocs) {
                        vm.documents = mydocs;
                        vm.documentsbk = mydocs;
                    });
            })
            .catch((err) => {
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function statusHistory(requestId: any) {
        utilityService.showLoading();
        vm.isStatusHistory = true;
        vm.requestId = requestId;

        taxNoticeService.retrieveStatusHistory(vm.requestId)
            .then(function (result) {
                vm.allStatuses[0] = result;
                utilityService.hideLoading();
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("StatusHistory: " + utilityService.getExceptionMessage(err));
            })
    }

    function download(taxNoticeDocumentId: any) {
        utilityService.showLoading();
        const identity = employeeService.retrieveIdentity()
            .then(function (identity) {
                return identity;
            });

        identity
            .then((result) => {
                vm.userName = result.UserName;
                taxNoticeService.downloadDocument({
                    TaxNoticeDocumentId: taxNoticeDocumentId,
                    UserName: result.UserName,
                    Text: 'downloading file',
                    TeamId: 'N/A',
                    TeamMemberEmpId: 'TeamMember'
                })
                    .then(function (result) {
                        if (result === true) {
                            utilityService.hideLoading();
                            return result;
                        }
                        utilityService.hideLoading();
                    })
                    .catch(function (ex) {
                        console.error(ex);
                        utilityService.hideLoading();
                        alert("Download failed: " + utilityService.getExceptionMessage(ex));
                    })
                return result;
            })
            .catch((err) => {
                utilityService.hideLoading();
                alert("Download failed: " + utilityService.getExceptionMessage(err));
            })
    }

    function onChangeFilters() {
        vm.filterDocs = vm.documentsbk;
        if (vm.filters.clientName) {
            vm.filterDocs = vm.filterDocs.filter(x => x.CompanyName.toLowerCase()
                .includes(vm.filters.clientName.toLowerCase()));
        }
        if (vm.filters.owner) {
            vm.filterDocs = vm.filterDocs.filter(x => x.OwnerName.toLowerCase()
                .includes(vm.filters.owner.toLowerCase()));
        }
        if (vm.filters.noticeNumber) {
            vm.filterDocs = vm.filterDocs.filter(x => String(x.RequestNumber) === String(vm.filters.noticeNumber));
        }
        if (vm.filters.uploadFrom) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) >= vm.filters.uploadFrom);
        }
        if (vm.filters.uploadTo) {
            vm.filterDocs = vm.filterDocs.filter(x => new Date(x.CreatedOn) <= vm.filters.uploadTo);
        }
        vm.documents = vm.filterDocs;
        console.log(vm.filterDocs);
    }
}
